import { IUser } from "../interfaces/user"

export const SET = "SET_USER"

export const setUser = (user: IUser) => ({
  type: SET,
  payload: user
})

export function reducer(state = null, { type, ...action }: any) {
  switch (type) {
    case SET:
      return action.payload
    default:
      return state
  }
}

export default reducer
